import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../utils/api';

const UnpaidStudentsPrint = () => {
    const [data, setData] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [institution, setInstitution] = useState('');
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get(`/reports/unpaid-students${location.search}`);
                setData(response.data?.data || []);
                setSelectedMonths(response.data?.selected_months || []);
                setInstitution(response.data?.institution || '');
                setLoading(false);
                
                // Trigger print after data is loaded and rendered
                setTimeout(() => {
                    window.print();
                }, 1000);
            } catch (err) {
                console.error("Error fetching unpaid students for print:", err);
                setLoading(false);
            }
        };

        fetchData();
    }, [location.search]);

    if (loading) {
        return <div className="p-10 text-center">جاري تحميل البيانات...</div>;
    }

    const groupedData = Object.entries(
        data.reduce((acc, item) => {
            const region = item.region_name || 'بدون منطقة';
            if (!acc[region]) {
                acc[region] = [];
            }
            acc[region].push(item);
            return acc;
        }, {})
    );

    return (
        <div className="print-page" dir="rtl">
            <div className="header">
                <div className="association-info">
                    <img src="/logo.png" alt="Logo" className="logo" />
                    <div className="text text-right">
                        <h1>جمعية تنمية النقل المدرسي</h1>
                        <h2>ولاد دحو</h2>
                    </div>
                </div>
                <div className="report-title">
                    <h3>لائحة التلاميذ غير المسددين</h3>
                    <div className="filters-summary">
                        الأشهر المختارة: {selectedMonths.join('، ')}
                        {institution && <span> | المؤسسة: {institution}</span>}
                        <span> | العدد الإجمالي: {data.length} تلميذ</span>
                    </div>
                </div>
            </div>

            {groupedData.length === 0 ? (
                <div className="text-center p-4">لا توجد بيانات ليتم طباعتها</div>
            ) : (
                groupedData.map(([region, students]) => (
                    <div key={region} className="region-section">
                        <h4 className="region-title">المنطقة: {region} ({students.length} تلميذ)</h4>
                        <table className="print-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }}>#</th>
                                    <th style={{ width: '30%' }}>الاسم الكامل</th>
                                    <th style={{ width: '15%' }}>رقم مسار</th>
                                    <th style={{ width: '15%' }}>القسم</th>
                                    <th style={{ width: '35%' }}>الأشهر غير المسددة</th>
                                </tr>
                            </thead>
                            <tbody>
                                {students.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td className="font-bold text-right">{item.full_name}</td>
                                        <td>{item.code_massar}</td>
                                        <td>{item.class_name}</td>
                                        <td className="text-red-600 font-bold">
                                            {item.unpaid_months.join('، ')}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))
            )}

            <div className="footer">
                <p>تاريخ الاستخراج: {new Date().toLocaleDateString('ar-MA')}</p>
            </div>

            <style dangerouslySetInnerHTML={{ __html: `
                @import url('https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@400;700&display=swap');
                
                @page {
                    size: A4;
                    margin: 15mm;
                }

                body {
                    font-family: 'Noto Kufi Arabic', sans-serif;
                    margin: 0;
                    padding: 0;
                    color: #333;
                }

                .print-page {
                    width: 100%;
                }

                .header {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 30px;
                    border-bottom: 2px solid #eea508;
                    padding-bottom: 15px;
                }

                .association-info {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 20px;
                    width: 100%;
                    margin-bottom: 20px;
                }

                .logo {
                    height: 80px;
                    object-fit: contain;
                }

                .header h1 {
                    margin: 0;
                    font-size: 22px;
                    color: #1e293b;
                }

                .header h2 {
                    margin: 0;
                    font-size: 18px;
                    color: #eea508;
                }

                .report-title {
                    text-align: center;
                }

                .report-title h3 {
                    margin: 10px 0;
                    font-size: 20px;
                    text-decoration: underline;
                }

                .filters-summary {
                    font-size: 11px;
                    color: #64748b;
                    margin-top: 5px;
                }

                .region-section {
                    margin-bottom: 25px;
                    page-break-inside: auto;
                }

                .region-title {
                    font-size: 14px;
                    font-weight: bold;
                    color: #fff;
                    background-color: #eea508;
                    padding: 8px 12px;
                    margin: 0;
                    border: 1px solid #cbd5e1;
                    border-bottom: none;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }

                .print-table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .print-table th, .print-table td {
                    border: 1px solid #cbd5e1;
                    padding: 8px 6px;
                    text-align: center;
                    font-size: 11px;
                }

                .print-table th {
                    background-color: #f8fafc;
                    color: #475569;
                    font-weight: 700;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }

                .text-right {
                    text-align: right !important;
                }

                .text-red-600 {
                    color: #dc2626;
                }

                .font-bold {
                    font-weight: 700;
                }

                .footer {
                    margin-top: 40px;
                    text-align: left;
                    font-size: 10px;
                    color: #94a3b8;
                }

                @media print {
                    .no-print {
                        display: none;
                    }
                }
            `}} />
        </div>
    );
};

export default UnpaidStudentsPrint;
